import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { mediaUrl } from "@/lib/config/app";
import Link from "next/link";
import PureHtml from "@/components/custom/PureHtml";
export default function FeaturedLinks(t0) {
  const $ = _c(16);
  const {
    flinks
  } = t0;
  let t1;
  if ($[0] !== flinks.alinks) {
    t1 = flinks?.alinks || [];
    $[0] = flinks.alinks;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const ilinks = t1;
  const fstyle = flinks?.style || "style1";
  const t2 = `featured-links py-3 lg:py-4 ${fstyle}`;
  let t3;
  if ($[2] !== flinks.heading) {
    t3 = <h2 className="text-xl lg:text-2xl">{flinks.heading}</h2>;
    $[2] = flinks.heading;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = flinks?.subtext;
  let t5;
  if ($[4] !== t4) {
    t5 = <PureHtml html={t4} />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== fstyle || $[7] !== ilinks) {
    t6 = ilinks?.length > 0 && <div className={`grid grid-cols-2 ${fstyle === "style7a" || fstyle === "style7b" ? "lg:grid-cols-6" : "lg:grid-cols-4"} gap-2 lg:gap-3`}>{ilinks.map((alink, index) => {
        const key = alink?.id || index;
        const stitle = alink?.ctitle || alink?.title || "Collection";
        const imageAlt = alink?.image_alt || alink?.ctitle || alink?.title || "Collection";
        const linkurl = alink?.link || "/";
        const aimage = `${mediaUrl}${alink?.image_url || "noimage.png"}`;
        const content = renderCard(fstyle, stitle, aimage, imageAlt);
        if (fstyle === "style3") {
          return <div key={key} title={stitle} className="pics">{content}</div>;
        }
        return <Link key={key} href={linkurl} className="alink" title={stitle}>{content}</Link>;
      })}</div>;
    $[6] = fstyle;
    $[7] = ilinks;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t5 || $[11] !== t6) {
    t7 = <div className="max-w-7xl mx-auto px-2">{t3}{t5}{t6}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t2 || $[14] !== t7) {
    t8 = <section className={t2}>{t7}</section>;
    $[13] = t2;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}
function renderCard(fstyle, stitle, aimage, imageAlt) {
  switch (fstyle) {
    case 'style1':
      return <div className={'relative shadow border border-secondary/20 rounded'} style={{
        aspectRatio: '4/5'
      }}>
                    <Image src={aimage} alt={`Shop ${imageAlt}`} width={320} height={320} quality={70} sizes="(max-width: 768px) 50vw, 25vw" className={`rounded w-full h-auto ${fstyle === 'style6' && 'rounded-full'}`} />
                    <h3 className={'fcatname py-2 ps-4 pe-8 w-fit border-l-0 drop-shadow-gray-500 drop-shadow-xs absolute left-0 top-9 font-heading text-base text-slate-700 leading-tight before:bg-white before:top-0 before:left-0 before:absolute before:h-full before:inset-0 before:w-full before:-z-1 before:[clip-path:polygon(0_0,100%_0,calc(100%-20px)_100%,0_100%)]'}>
                        {stitle}
                    </h3>
                </div>;
    case 'style1b':
      return <div className={'relative shadow border border-secondary/20 rounded'}>
                    <Image src={aimage} width={320} height={320} alt={`Shop ${imageAlt}`} sizes="(max-width: 768px) 50vw, 25vw" className={'rounded w-full h-auto'} />
                    <div className={'absolute top-2 lg:top-4 left-2 lg:left-4'}>
                        <h3 className={'text-base lg:text-xl font-heading mb-1 lg:mb-2 text-white drop-shadow-black drop-shadow-xs'}>{stitle}</h3>
                        <div className={'text-xs lg:text-sm font-heading inline-block py-0.5 px-3 rounded bg-primary text-white text-shadow-xs text-shadow-gray-600 shadow'}>Shop Now</div>
                    </div>
                </div>;
    case 'style2':
      return <div className={'relative shadow border border-secondary/20 rounded'}>
                    <Image src={aimage} width={320} height={320} alt={`Shop ${imageAlt}`} sizes="(max-width: 768px) 50vw, 24vw" className={'rounded w-full h-auto'} quality={50} />
                    <h3 className={'hidden'}>{stitle}</h3>
                </div>;
    case 'style4':
      return <div>
                    <div className={'relative shadow border border-secondary/20 rounded'}>
                        <Image src={aimage} width={320} height={320} alt={`Shop ${imageAlt}`} quality={50} sizes="(max-width: 768px) 45vw, 21vw" className={`w-full h-auto rounded`} />
                    </div>
                    <div className={'relative bg-white/90 px-2 mt-2'}>
                        <h3 className={'text-sm lg:text-base font-heading py-1 line-clamp-1 text-center capitalize'}>
                            {stitle}
                        </h3>
                    </div>
                </div>;
    case 'style5':
      return <div className={'relative shadow border border-secondary/20 rounded'}>
                    <Image src={aimage} alt={`Shop ${imageAlt}`} quality={60} width={350} height={350} sizes="(max-width: 768px) 50vw, 25vw" className={`w-full h-auto rounded`} />
                    <h3 className={'absolute top-2 lg:top-4 left-2 lg:left-1/20 bg-white/90 px-2 rounded shadow-lg w-9/10'}>
                        <div className={'text-sm lg:text-base font-heading py-1 line-clamp-1 text-center capitalize'}>{stitle}</div>
                    </h3>
                </div>;
    case 'style5b':
      return <div className={'relative shadow border border-secondary/20 rounded'}>
                    <Image src={aimage} alt={`Shop ${imageAlt}`} quality={60} width={350} height={350} sizes="(max-width: 768px) 50vw, 25vw" className={`w-full h-auto rounded`} />
                    <h3 className={'absolute bottom-2 lg:bottom-4 left-2 lg:left-1/20 bg-white/90 px-2 rounded shadow-lg w-9/10'}>
                        <div className={'text-sm lg:text-base font-heading py-1 line-clamp-1 text-center capitalize'}>{stitle}</div>
                    </h3>
                </div>;
    case 'style6':
      return <div>
                    <div className={'relative shadow border border-secondary/20 rounded-full aspect-square'}>
                        <Image src={aimage} alt={`Shop ${imageAlt}`} quality={70} fill sizes="(max-width: 768px) 50vw, 25vw" className={`w-full h-auto rounded-full`} />
                    </div>
                    <div className={'relative bg-white/90 px-2 mt-2'}>
                        <h3 className={'text-sm lg:text-base font-heading py-1 line-clamp-1 text-center capitalize'}>
                            {stitle}
                        </h3>
                    </div>
                </div>;
    case 'style7a':
      return <div className={'relative bg-linear-to-r  from-primary/80 via-primary to-primary/70 px-2 py-3 rounded shadow-md shadow-primary/30'}>
                    <h3 className={'text-sm lg:text-base font-heading line-clamp-1 text-white text-shadow-gray-600 text-shadow-xs text-center capitalize'}>
                        {stitle}
                    </h3>
                </div>;
    case 'style7b':
      return <div className={'relative border-2 border-primary bg-primary/5 px-2 py-3 rounded shadow'}>
                    <h3 className={'text-sm lg:text-base font-heading line-clamp-1 text-center capitalize'}>
                        {stitle}
                    </h3>
                </div>;
    default:
      return null;
  }
}